import { render, staticRenderFns } from "./NotificationSubscriptionList.vue?vue&type=template&id=205439dd&scoped=true&"
import script from "./NotificationSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./NotificationSubscriptionList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSubscriptionList.vue?vue&type=style&index=0&id=205439dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205439dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205439dd')) {
      api.createRecord('205439dd', component.options)
    } else {
      api.reload('205439dd', component.options)
    }
    module.hot.accept("./NotificationSubscriptionList.vue?vue&type=template&id=205439dd&scoped=true&", function () {
      api.rerender('205439dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/NotificationSubscriptionList.vue"
export default component.exports